// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import FloatingTooltip, {
    FloatingTooltipProps,
    FloatingTooltipStyles,
} from "@sc/App/Components/FloatingTooltip/FloatingTooltip";
import { tooltipDefaultProps } from "@sc/App/Components/FloatingTooltip/presentationProps";
import { mergeWithCss } from "@sc/XDL/Utilities";
import React, { FC, PropsWithChildren, useState } from "react";

const DEFAULT_BOUNDARY_SELECTOR = "#header-container";

export const floatingMenuTooltip: FloatingTooltipStyles = {};

const FloatingMenuTooltip: FC<PropsWithChildren<FloatingTooltipProps>> = ({ children, extendedStyles, ...props }) => {
    const [styles] = useState(() => mergeWithCss(floatingMenuTooltip, extendedStyles));

    return (
        <FloatingTooltip
            {...props}
            showArrow={false}
            extendedStyles={styles}
            shift={{
                ...tooltipDefaultProps.shift,
                ...props.shift,
                boundary:
                    typeof document !== "undefined"
                        ? document.querySelector(DEFAULT_BOUNDARY_SELECTOR) || document.body
                        : "clippingAncestors",
            }}
        >
            {children}
        </FloatingTooltip>
    );
};

export default FloatingMenuTooltip;
